import React, { useContext } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import Navbar from "../navbar/navbar";
import { GlobalAppContext } from "./../../context";
// import Profile from "../components/profile";
import Profile from "../components/userProfile";
import NotFound from "../components/notFound";
import Home from "../components/home/home";
import ForgotPassword from "../components/forgotPassword";
import Footer from "../components/footer";
import Portfolio from "../components/portfolio/portfolio";
import Login from "../components/login";
import Blog from "../components/blog/blog";
import CommingSoon from "../common/commingSoon";
import ScrollToTop from "../components/scrollToTop";
import ProtectedRoute from "../common/protectedRoute";
import UserBlog from "../components/blog/userBlog";
import BlogPage from "../components/blog/blogPage";

const MainContent = () => {
  const { toggled, setToggled } = useContext(GlobalAppContext);

  return (
    <main className="page-content">
      <Navbar></Navbar>
      <div className="overlay" onClick={() => setToggled(!toggled)}></div>
      <div className="routes">
        <Switch>
          <Route path="/not-found" component={NotFound}></Route>
          {/* <Route path="/blog/user/:userId" component={UserBlog}></Route>
          <Route path="/blog/post/:postId" component={BlogPage}></Route> */}
          <Route path="/blog" component={Blog}></Route>
          <Route path="/portfolio" component={Portfolio}></Route>
          <Route path="/forum" component={CommingSoon}></Route>
          <Route path="/technologies" component={CommingSoon}></Route>
          <Route path="/login" component={Login}></Route>
          <Route path="/about" component={CommingSoon}></Route>
          <Route path="/forgot-password" component={ForgotPassword}></Route>
          <ProtectedRoute path="/profile" component={Profile}></ProtectedRoute>
          <Route path="/" exact component={Home}></Route>
          {/* <Redirect from="/" exact to="/inspire"></Redirect> */}
          <Redirect to="/not-found"></Redirect>
        </Switch>
      </div>
      <Footer></Footer>
      <ScrollToTop></ScrollToTop>
    </main>
  );
};

export default MainContent;
